import { collection, getDocs, query, where } from 'firebase/firestore';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { db } from '../../config/firebase';
import { Context as AppContext } from "../../context/AppContext";
import { enums } from "../../utils/enums-no-imports";
import {MainLayout} from '../../layouts/main-layout/MainLayout';
import { 
  Container, 
  Typography, 
  Grid, 
  Card, 
  CardContent, 
  CardActions, 
  Button, 
  CircularProgress, 
  Box, 
  Paper
} from '@mui/material';

const StudentHomepage = () => {
    const { state: { currentUser }, setGPTs } = useContext(AppContext);
    const navigate = useNavigate();
    const [gpts, setGpts] = useState([]);
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        if (currentUser?.role !== enums.STUDENT) {
            navigate('/');
            return;
        }
        
        const fetchGpts = async () => {
            try {
                // Get GPTs from the teacher associated with this student
                const teacherUid = currentUser?.teacherUid;
                
                if (teacherUid) {
                    const gptsQuery = query(
                        collection(db, "gpts"),
                        where("createdBy", "==", teacherUid)
                    );
                    
                    const querySnapshot = await getDocs(gptsQuery);
                    const gptsData = querySnapshot.docs.map(doc => ({
                        id: doc.id,
                        ...doc.data()
                    }));
                    
                    setGpts(gptsData);
                    setGPTs(gptsData);
                }
            } catch (error) {
                console.error("Error fetching GPTs:", error);
            } finally {
                setLoading(false);
            }
        };
        
        fetchGpts();
    }, [currentUser, navigate]);

    console.log(gpts);

    return (
        <MainLayout>

        <Container sx={{ py: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom>
                Student Dashboard
            </Typography>
            
            <Typography variant="h5" component="h2" sx={{ mb: 3 }}>
                Available GPTs
            </Typography>
            
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                    <CircularProgress />
                </Box>
            ) : gpts.length > 0 ? (
                <Grid container spacing={3}>
                    {gpts.map((gpt) => (
                        <Grid item xs={12} sm={6} md={4} key={gpt.id}>
                            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                <CardContent sx={{ flexGrow: 1 }}>
                                    <Typography variant="h6" component="div">
                                        {gpt.title}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {gpt.assistantDescription || "No description available"}
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <Button 
                                        fullWidth 
                                        variant="contained" 
                                        onClick={() => navigate(`/class-gpt/${gpt.uid}`)}
                                    >
                                        Open GPT
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            ) : (
                <Paper sx={{ p: 3, textAlign: 'center', bgcolor: 'background.default' }}>
                    <Typography>No GPTs available from your teacher yet.</Typography>
                </Paper>
            )}
        </Container>
        </MainLayout>

    );
};

export default StudentHomepage;
